// ---------------------------------------------------------------------------
// cogibulle diffusion — Visionneuse des documents embarqués (mode embarqué)
//
// Les boutons du jeu web qui ouvrent un PDF en ligne (aide, mentions légales)
// n'ont pas de sens dans une appli hors ligne, et la WebView Android n'affiche
// pas les PDF. À la fabrication (appli/embarque_documents.js), chaque PDF est
// converti en images de pages rangées dans public/embarque/documents/, avec
// la table public/embarque/documents.json {url d'origine : [pages]}.
// Ici : ouverture plein écran, défilement, un toucher agrandit / réduit.
// ---------------------------------------------------------------------------

import { Template } from 'meteor/templating';
import { ReactiveVar } from 'meteor/reactive-var';
import { Tracker } from 'meteor/tracker';

import { pages_document_embarque } from '../runtime_embarque.js';

import './document_embarque.html';
import './document_embarque.css';

const gDocumentPages = new ReactiveVar (null);
const gDocumentAgrandi = new ReactiveVar (false);

export function url_est_document_embarque (pUrl)
  {
    return !!pages_document_embarque (pUrl);
  }

// Renvoie false si l'URL n'a pas de version embarquée.
export function ouvre_document_embarque (pUrl)
  {
    const tPages = pages_document_embarque (pUrl);
    if (!tPages) return false;
    gDocumentAgrandi.set (false);
    gDocumentPages.set (tPages);
    return true;
  }

Template.diffusionDocumentEmbarque.helpers (
  {
    document_ouvert ()
      {
        return !!gDocumentPages.get ();
      },

    document_pages ()
      {
        return gDocumentPages.get () || [];
      },

    document_classe ()
      {
        return gDocumentAgrandi.get () ? 'is-agrandi' : '';
      },
  });

Template.diffusionDocumentEmbarque.events (
  {
    'click .js_document_page' (pEvent, pTpl)
      {
        // Agrandir autour du point touché, réduire en revenant en haut à gauche.
        const tZone = pTpl.find ('.js_document_defilement');
        const tImage = pEvent.currentTarget;
        const tRect = tImage.getBoundingClientRect ();
        const tRx = tRect.width ? (pEvent.clientX - tRect.left) / tRect.width : 0;
        const tRy = tRect.height ? (pEvent.clientY - tRect.top) / tRect.height : 0;
        const tAgrandi = !gDocumentAgrandi.get ();
        gDocumentAgrandi.set (tAgrandi);
        if (!tZone) return;
        // Après le rendu Blaze de la classe is-agrandi, sinon rien n'a bougé.
        Tracker.afterFlush (() =>
          {
            if (!tAgrandi)
              {
                tZone.scrollLeft = 0;
                return;
              }
            const tNouveau = tImage.getBoundingClientRect ();
            tZone.scrollLeft += tNouveau.left + tRx * tNouveau.width - pEvent.clientX;
            tZone.scrollTop += tNouveau.top + tRy * tNouveau.height - pEvent.clientY;
          });
      },

    'click .js_document_fermer' ()
      {
        gDocumentPages.set (null);
      },
  });
